import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { link } from '../utils/styles';
import LinkFade from './LinkFade';

const Styled = styled.span`
  a {
    ${link};
  }
`;

const renderInner = ({ children, to, href, ...rest }) => {
  switch (true) {
    case to !== undefined:
      return (
        <LinkFade to={to} {...rest}>
          {children}
        </LinkFade>
      );
    case href !== undefined:
      return (
        <a href={href} {...rest}>
          {children}
        </a>
      );
    default:
      return children;
  }
};

renderInner.propTypes = {
  to: PropTypes.string,
  href: PropTypes.string,
};

const StyledLink = ({ className, color, ...rest }) => (
  <Styled className={className} color={color}>
    {renderInner(rest)}
  </Styled>
);

StyledLink.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

export default StyledLink;



// WEBPACK FOOTER //
// ./src/components/StyledLink.js